import { render, staticRenderFns } from "./shenUseSealDetail.vue?vue&type=template&id=98f9db6e&"
import script from "./shenUseSealDetail.vue?vue&type=script&lang=js&"
export * from "./shenUseSealDetail.vue?vue&type=script&lang=js&"
import style0 from "./shenUseSealDetail.vue?vue&type=style&index=0&id=98f9db6e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports